import { get } from "./request";
// 设备型号下拉列表
export const deviceSelect = async () => {
  return get('bluetoothlight/web/device/models/select')
}
